"use client";

import React from "react";
import Image from "next/image";
import ScrollyImage from "@/components/common/ScrollyImage";
import styles from "./BrandBanner.module.scss";

interface BrandBannerProps {
	image: string;
	brandName: string;
	height?: "small" | "medium" | "large";
}

const BrandBanner: React.FC<BrandBannerProps> = ({ image, brandName, height = "medium" }) => {
	return (
		<section className={`${styles["brand-banner"]} ${styles[`brand-banner--${height}`]}`}>
			<ScrollyImage>
				<img src={image} alt={brandName} className={styles["brand-banner__image"]} />
			</ScrollyImage>
		</section>
	);
};

export default BrandBanner;
